import _ from "lodash";
const initialState = {};

const showAddTaskInput = (state = initialState, action) => {
  if (action.type === "TOGGLE_SHOW_ADD_TASK_INPUT") {
      const projectid = action.payload.projectId;
      try {
          const activeProjectId = Object.keys(state).filter(
              (projectId) => state[projectId] === true
          );
          const statecopy = _.cloneDeep(state);
          if (!statecopy[projectid]) {
              if (activeProjectId[0]) {
                  statecopy[activeProjectId] = false;
                  statecopy[projectid] = true;
              } else {
                  statecopy[projectid] = true;
              }
              return statecopy;
          } else {
              if (activeProjectId[0] === projectid) {
                  statecopy[projectid] = false;
                  return statecopy;
              }
          }
      } catch (exception) {
          console.log("Error in showAddTaskInput: " + exception);
      }
    
  }
  return state;
};

export default showAddTaskInput;
